import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription} from "../../../../../user/user-subscription";
import {filter, first, switchMap, takeUntil, tap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {User} from "../../../../../user/user";
import {WebsiteService} from "../../../../../websites/website.service";
import {Subject} from "rxjs";
import {Router} from "@angular/router";
import {HostingService} from "../../../../../websites/website/hosting/hosting.service";
import {DbModalService} from "../../../../../modules/modal/modal";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {ProductService} from "../../../../../websites/website/product.service";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {
  GenerationFailedComponent
} from "../../../../../components/pages/setup/create-ai/create-ai-assistant/generation-failed/generation-failed.component";
import {Utils} from "../../../../utils/utils";
import {Config} from "../../../../../config/config";
import {ActivityAction, ActivityStatus} from "../../../../../activities/activity";
import {UserService} from "../../../../../user/user.service";

@Component({
    selector: 'db-demo-progress-step',
    templateUrl: './demo-progress-step.component.html',
    styleUrls: ['./demo-progress-step.component.scss'],
    standalone: false
})
export class DemoProgressStepComponent implements OnInit {

  @Input() user: User;
  @Input() campaignInfo: any;
  @Input() userLocalStorage: any;
  @Input() websiteData: any;
  @Input() isAvailableEcommerceFeatures: boolean;
  @Input() isEcommerceWebsite: boolean = false;
  @Input() forceImport: boolean = false;
  @Input() subscription: UserSubscription;
  @Input() showSetupFlow: boolean = false;
  @Input() currentStep = 0;

  @Output() onFinished: EventEmitter<any> = new EventEmitter();
  @Output() websiteUrlUpdate: EventEmitter<string> = new EventEmitter<string>();

  public steps: any;
  public isMobile: boolean;
  public pageId = '';
  feedbackSubmitted = true;
  templateType: string;
  header: any;
  fadeInProgressList = false;

  private websiteUrl = '';
  private websiteId: number;
  private currentSubscription: UserSubscription;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _userService: UserService,
    private readonly _router: Router,
    private readonly _hostingService: HostingService,
    private readonly _modalService: DbModalService,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _websiteService: WebsiteService,
    private readonly activeModal: DbActiveModal,
    private readonly _productService: ProductService
  ) {
  }

  ngOnInit() {
    this._getCurrentSubscription();
    this.activeModal.hideCloseBtn(true);
    this.isMobile = window.innerWidth <= 768;
    if ((this.websiteData && Object.keys(this.websiteData).length > 0 && !this.showSetupFlow) || this.forceImport) {
      this._createWebsiteForAi('us-central1-c');
    } else {
      this.getRegion();
    }
    this.startAnimation();
    this.steps = ['Configuring high performance hosting', 'Finalizing your website'];
  }

  startAnimation() {
    this.header = {
      subheader: `You got 10Web ${!this.subscription?.trialClient ? this.subscription?.plan?.title : ''} for`,
      header: `${this.campaignInfo ? (this.campaignInfo?.couponDays == 30 ? '1 month ' : this.campaignInfo?.couponDays + ' days') : '7 days'} for free ` +
        (this.campaignInfo?.couponPercent ? `& <span class="discount-text">${this.campaignInfo.couponPercent}% off</span>` : ''),
      desc: 'We’re adding the final touches for a smooth start.'
    };
    const totalAnimationTime =
      (this.header.subheader.length * 0.04 +
        this.header.header.length * 0.04 +
        this.header.desc.length * 0.04 +
        1) * 1000; // Convert to milliseconds

    // Trigger fade-in after animations
    setTimeout(() => {
      this.fadeInProgressList = true;
      setTimeout(() => this.currentStep += 1, 4000);
    }, totalAnimationTime);
  }

/*  showProgressOrSuccess() {
    this.feedbackSubmitted = true;
    this.isSurveySubmitted.emit(true);
    if (this.websiteId) {
      setTimeout(() => {
        this.onFinished.emit({templateType: this.templateType, websiteId: this.websiteId});
      }, 1000);
    }
  }*/


  protected recreateWebsite(retry?: boolean) {
    this._websiteService.recreateWithAiAssistant(this.websiteId, null, retry)
      .pipe(
        first(response => !!response)
      )
      .subscribe(response => {
        if (!response.success) {
          return this._showFailedDialog();
        }
      });
  }

  private getRegion() {
    this._hostingService.regions(this.user.subscriptionId)
      .pipe(
        first(response => !!response)
      )
      .subscribe(response => {
        if (response.success) {
          const defaultRegion = response.data && response.data.find(region => region.is_available);
          const region = defaultRegion && defaultRegion.zone || null;
          this._createWebsiteForAi(region);
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private _createWebsiteForAi(region = ''): void {
    /*TODO REFACTOR IN JANUARY*/

    if (this.websiteData && Object.keys(this.websiteData).length > 0) {
      if (this.userLocalStorage) {
        if (this.userLocalStorage.themeId) {
          this.websiteData["themeId"] = this.userLocalStorage.themeId;
        }
        if (this.userLocalStorage.isBuilderV2) {
          this.websiteData["pipeline"] = 'ai2';
        }
        if (this.userLocalStorage.fontFamily) {
          this.websiteData["fontFamily"] = this.userLocalStorage.fontFamily;
        }
        if (this.userLocalStorage.colorPallet) {
          this.websiteData["colorPallet"] = this.userLocalStorage.colorPallet;
        }
      }

      if (this.showSetupFlow) {
        this._hostingService.createWebsite(this.websiteData, true)
          .pipe(
            filter(response => !!response),
            first()
          )
          .subscribe(response => {
            if (!response.success) {
              NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
            } else {
              if (!this.websiteUrl && response.data && response.data.site_url) {
                this.websiteUrl = response.data.site_url;
                this.websiteUrlUpdate.emit(this.websiteUrl);
                this.pageId = response.data.page_id;
                this.websiteId = response.data.domain_id;
              }
              this.pageId = response.data.page_id;
              this.templateType = response.data.template_type;
              this._afterCreate(response?.data?.template_type);
            }
          });
      } else {
        this._hostingService.createWebsiteForTrialUsers(this.websiteData, true)
          .pipe(
            filter(response => !!response),
            first()
          )
          .subscribe(response => {
            if (!response.success) {
              NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
            } else {
              if (!this.websiteUrl && response.data && response.data.site_url) {
                this.websiteUrl = response.data.site_url;
                this.websiteUrlUpdate.emit(this.websiteUrl);
                this.pageId = response.data.page_id;
                this.websiteId = response.data.domain_id;
              }
              this.pageId = response.data.page_id;
              this.templateType = response.data.template_type;
              this._afterCreate(response?.data?.template_type);
            }
          });
      }
    } else {
      const data = {
        region: region,
        siteTitle: 'My Website'
      };

      if (this.userLocalStorage) {
        !this.websiteData && (this.websiteData = {});
        if (this.userLocalStorage.themeId) {
          this.websiteData["themeId"] = this.userLocalStorage.themeId;
        }
        if (this.userLocalStorage.isBuilderV2) {
          this.websiteData["pipeline"] = 'ai2';
        }
      }

      if (this.userLocalStorage?.fontFamily) {
        this.websiteData["fontFamily"] = this.userLocalStorage.fontFamily;
        data["fontFamily"] = this.userLocalStorage.fontFamily;
      }
      if (this.userLocalStorage?.colorPallet) {
        this.websiteData["colorPallet"] = this.userLocalStorage.colorPallet;
        data["colorPallet"] = this.userLocalStorage.colorPallet;
      }

      this._hostingService.createWebsiteForTrialUsers(data, true)
        .pipe(
          first(response => !!response),
        )
        .subscribe(response => {
          if (!response.success) {
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          } else {
            if (!this.websiteUrl && response.data && response.data.site_url) {
              this.websiteUrl = response.data.site_url;
              this.websiteUrlUpdate.emit(this.websiteUrl);
              this.pageId = response.data.page_id;
              this.websiteId = response.data.domain_id;
            }
            this.pageId = response.data.page_id;
            this._afterCreate(response?.data?.template_type);
          }
        });
    }
  }

  private _getRecreateOngoingActivity(): void {
    this._store.select(fromStore.getOngoingActivity)
      .pipe(
        takeUntil(this._destroyStream$),
        tap(activity => activity && activity.websiteId && (this.websiteId = activity.websiteId)),
        tap(activity => activity && activity.meta && activity.meta.page_id && (this.pageId = activity.meta.page_id)),
        tap(activity => activity && activity.meta && activity.meta.site_url && (this.websiteUrl = activity.meta.site_url)),
        filter(activity => activity && ((activity.websiteId && (activity.websiteId === this.websiteId || activity.websiteId === Config.demoDomainId)) || !activity.websiteId)
          && (activity.action === ActivityAction.INSTALL || activity.action === ActivityAction.INSTALL_HOSTED_TEMPLATE)
          && (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED))
      )
      .subscribe(activity => {
        this.websiteUrlUpdate.emit(this.websiteUrl);
        this.currentStep += 1;
      });
  }

  private _afterCreate(template_type) {
    this._store.dispatch(new fromStore.LoadWebsites());
    this._store.dispatch(new fromStore.LoadUserSubscription());
    this._store.dispatch(new fromStore.LoadUser());
    if (this.websiteId) {
      this._hostingService.whiteListIp(this.websiteId, this.websiteUrl);
      template_type === 'ecommerce' && this._store.dispatch(new fromStore.LoadEcommerceSetupList({websiteId: this.websiteId}));
      this._productService.updateScreenShot(this.websiteId);
    }
      setTimeout(() => {
        this.onFinished.emit({templateType: template_type, websiteId: this.websiteId});
      }, 1000);
  }


  private _showFailedDialog(): void {
    const modal = this._modalService.open(GenerationFailedComponent, {width: 500, hasCloseBtn: false});
    modal.componentInstance.canRetry = false;
    modal.closed.subscribe(() => {
      this.recreateWebsite(true);
    });
    modal.dismissed.subscribe(res => {
      if (res === 'chat') {
        this._router.navigate(['/websites/']);
        this.openChat();
      }
    });
  }

  private openChat() {
    /*window['zE']('messenger', 'chat:removeTags', ['generic_support']);
    window['zE']('messenger', 'chat:addTags', ['open_livechat']);*/

    window['Smooch']?.open();
    /*window['zE']('messenger', 'chat:send', 'I encountered an issue while importing my AI generated website.');*/
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

  private _getCurrentSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        takeUntil(this._destroyStream$)
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.currentSubscription = userSubscription;
        this.header = {
          subheader: `You got 10Web ${this.currentSubscription?.plan?.title} for`,
          header: `${this.campaignInfo ? (this.campaignInfo?.couponDays == 30 ? '1 month ' : this.campaignInfo?.couponDays + ' days') : '7 days'} for free ` +
            (this.campaignInfo?.couponPercent ? `& <span class="discount-text">${this.campaignInfo.couponPercent}% off</span>` : ''),
          desc: 'We’re adding the final touches for a smooth start.'
        };
      });
  }
}
